export default {
  pageid: '40035613', // 页面pageid
  cid: 'c_ywm5nx3j', // 页面cid
  shopServerBid: 'b_8twjj2bq', // 商户服务模块bid,携带click_name 点击点 ok ok
  extendNavBid: 'b_84rj1pbl', // 扩展导航bid,携带click_name category 曝光点 ok
  footerViewBid: 'b_7fsaymtd', // 页尾曝光bid,携带基本信息 曝光点 ok ok
  inputSearchBid: 'b_f4h4gax0', // 搜索框bid,携带基本信息 点击点 ok ok
  siteNavViewBid: 'b_w6ivk1jc', // 网站导航曝光bid,携带基本信息 曝光点 ok ok
  userInforBid: 'b_4ntd0ob1', // 个人信息bid,携带click_name 点击点 ok
  searchBntBid: 'b_rk3s8vlt', // 搜索按钮bid,携带click_name 点击点 ok ok
  logoBid: 'b_yiymhq4t', // logo模块bid,携带基本信息 点击点 ok ok
  cityBid: 'b_u8c8mode', // 城市bid,携带基本信息 点击点 ok ok
  userCenterBid: 'b_99kj6dpa', // 个人中心bid,携带click_name 点击点 ok ok
  loginBid: 'b_dhrgcw82', // 未登录模块bid,携带click_name 点击点 ok
  moreCataBid: 'b_0dzasdhz', // 扩展导航 携带 click_name category 点击点 ok ok
  rowCateBid: 'b_zjjbgeg1', // 横向导航bid,携带click_name 点击点 ok ok
  footerClickBid: 'b_1huqreyt', // 页尾click bid,携带基本信息 点击点 ok ok
  allCateBid: 'b_l1yhtqp6', // 全部分类bid,携带携带基本信息 点击点 目前不可点击 ok
  mainCateBid: 'b_naj4y23e', // 左侧主导航bid,携带click_title click_name category 点击点 ok ok
  writeReviewBid: 'b_i2q5vait', // 写点评bid,携带基本信息 ok 点击点 ok
  helpCenterBid: 'b_ys0014fx', // 帮助中心bid,携带click_name ok 点击点 ok
  messageBid: 'b_5mzan27d', // 消息bid,携带click_name 点击点 ok ok
  hotWordsBid: 'b_yalm50ja' // 热搜词bid,携带基本信息 点击点 ok ok
}


// WEBPACK FOOTER //
// ./modules/common/js/lx-bid.js